import includes from 'lodash/includes'
import reduce from 'lodash/reduce'
import React, { FC, ReactNode, useContext } from 'react'

import { BarFactory } from '@Components/CMS/Bar/BarFactory'
import { SplitTestGroup } from '@Generated/graphql'
import { MetadataContext } from '@Globals/Metadata'
import { useCheapestShippingPrice } from '@Globals/Metadata/Hooks'
import { Experiment } from '@Globals/SplitTests/Experiment'
import { Test } from '@Globals/SplitTests/types'

interface Props {
  placement: string
}

export const CMSBar: FC<Props> = ({ placement }) => {
  const { bars } = useContext(MetadataContext)
  const cheapestShippingPrice = useCheapestShippingPrice()
  const isGlobalShippingFree = cheapestShippingPrice === null || cheapestShippingPrice?.value === 0

  return (
    <>
      {
        reduce(bars, (acc: ReactNode[], bar) => {
          if (!includes(bar.placement, placement)) {
            return acc
          }

          if (bar.conditions?.includes('with_global_free_shipping') && !isGlobalShippingFree) {
            return acc
          }

          if (bar.conditions?.includes('without_global_free_shipping') && isGlobalShippingFree) {
            return acc
          }

          const barComponent = (
            <BarFactory
              key={bar.id}
              bar={bar}
              id={`bar-${placement}-${bar.id}`}
              order={bar.priority}
              placement={placement}
              style={{ zIndex: '-1' }}
            />
          )

          if (bar?.splitTest?.test) {
            acc.push(
              <Experiment
                key={bar.id}
                a={includes(bar?.splitTest.groups, SplitTestGroup.A) ? barComponent : undefined}
                b={includes(bar?.splitTest.groups, SplitTestGroup.B) ? barComponent : undefined}
                c={includes(bar?.splitTest.groups, SplitTestGroup.C) ? barComponent : undefined}
                d={includes(bar?.splitTest.groups, SplitTestGroup.D) ? barComponent : undefined}
                test={bar?.splitTest.test as Test}
              />,
            )

            return acc
          }

          acc.push(barComponent)

          return acc
        }, [])
      }
    </>
  )
}
